import React, { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { useCurrentUser } from '../../../../utils/hooks/useCurrentUser';
import LoggedInMenu from './_partials/LoggedInMenu';
import LoggedOutMenu from './_partials/LoggedOutMenu';

interface Props {
  hideNotificationCount?: boolean;
  disableThemeSwitcher?: boolean;
  hasSubscriptions?: boolean;
}

const UserMenuMobile: React.FC<Props> = props => {
  const { isLoggedIn } = useContext(SessionContext);
  const currentUser = useCurrentUser();

  return isLoggedIn && currentUser ? (
    <LoggedInMenu {...props} />
  ) : (
    <LoggedOutMenu {...props} />
  );
};

UserMenuMobile.displayName = 'UserMenuMobile';

export default UserMenuMobile;
